<template>
  <section class="store-add">
    <Form
      class="form"
      ref="formValidate"
      :model="formValidate"
      :label-width="150"
    >
      <Form-item label="门店名称" prop="storeName">
        <Input
          v-model="formValidate.storeName"
          placeholder="给门店起个名字"
          style="flex: 1"
        ></Input>
      </Form-item>
      <Form-item label="推荐人编码（选填）" prop="refereeCode">
        <Input
          v-model="formValidate.refereeCode"
          placeholder="推荐人的编码"
          style="flex: 1"
        ></Input>
      </Form-item>
      <Form-item label="营业执照" prop="imgLecienceUrl">
        <Upload
          ref="upload"
          :show-upload-list="false"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="2048"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="handleBeforeUpload"
          :handle-upload="handleUpload"
          photo-name="imgLecienceUrl"
          :default-photo="formValidate.imgLecienceUrl"
          type="drag"
          action="//jsonplaceholder.typicode.com/posts/"
          style="display: inline-block; width: 102px"
          :headers='{"token": $sessionToken()}'
        >
          <div class="uploadDiv">
            <Icon type="md-add" size="16" />
            <div>上传照片</div>
          </div>
        </Upload>
        <div class="uploadText">请上传JPG/PNG格式的图片，大小不超过5M</div>
      </Form-item>
      <Form-item label="营业执照编码" prop="lecienceCode">
        <Input
          v-model="formValidate.lecienceCode"
          placeholder="请填写营业执照编码"
          style="flex: 1"
        ></Input>
      </Form-item>
      <Form-item label="营业执照名称" prop="lecienceName">
        <Input
          v-model="formValidate.lecienceName"
          placeholder="请填写执照名称"
          style="flex: 1"
        ></Input>
      </Form-item>
      <Form-item label="认证类型" prop="certificateType">
        <RadioGroup v-model="formValidate.certificateType">
          <Radio label="00">
            <span>三证合一</span>
          </Radio>
          <Radio label="01">
            <span>三证</span>
          </Radio>
        </RadioGroup>
      </Form-item>
      <div v-if="showCertificateType">
        <Form-item label="组织机构代码编码" prop="orginizeCode">
          <Input
            v-model="formValidate.orginizeCode"
            placeholder="请输入组织机构代码编码"
            style="flex: 1"
          ></Input>
        </Form-item>
        <Form-item label="税务登记证编码" prop="taxlienceType">
          <Input
            v-model="formValidate.taxlienceType"
            placeholder="请输入税务登记证编码"
            style="flex: 1"
          ></Input>
        </Form-item>
      </div>
      <Form-item label="门头照片（选填）" prop="shopHeadImg">
        <Upload
          ref="upload"
          :show-upload-list="false"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="2048"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="handleBeforeUpload"
          :handle-upload="handleUpload"
          photo-name="shopHeadImg"
          :default-photo="formValidate.shopHeadImg"
          type="drag"
          action="//jsonplaceholder.typicode.com/posts/"
          style="display: inline-block; width: 102px"
          :headers='{"token": $sessionToken()}'
        >
          <div class="uploadDiv">
            <Icon type="md-add" size="16" />
            <div>上传照片</div>
          </div>
        </Upload>
        <div class="uploadText">请上传JPG/PNG格式的图片，大小不超过5M</div>
      </Form-item>
      <Form-item label="店内照片（选填）" prop="shopInImg">
        <Upload
          ref="upload"
          :show-upload-list="false"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="2048"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="handleBeforeUpload"
          :handle-upload="handleUpload"
          photo-name="shopInImg"
          :default-photo="formValidate.shopInImg"
          type="drag"
          action="//jsonplaceholder.typicode.com/posts/"
          style="display: inline-block; width: 102px"
          :headers='{"token": $sessionToken()}'
        >
          <div class="uploadDiv">
            <Icon type="md-add" size="16" />
            <div>上传照片</div>
          </div>
        </Upload>
        <div class="uploadText">请上传JPG/PNG格式的图片，大小不超过5M</div>
      </Form-item>

      <FormItem style="margin-left: 15px; margin-top: 20px" class="br">
        <Button @click="handleSave" type="primary" style="margin-right: 10px"
          >提交</Button
        >
        <Button @click="handleReset">取消</Button>
      </FormItem>
    </Form>
  </section>
</template>

<script>
import axios from "axios";
import { initFormValidate, ruleValidate } from "./validate/rule";
import uploadPhoto from "@/views/store/components/uploadPhoto";
import amapControls from "@/views/store/components/amapControls";

export default {
  name: "store-edit",
  components: {
    uploadPhoto,
    amapControls,
  },
  data() {
    const { retCode } = this.$route.query;
    return {
      visible: true,
      spinShow: true,
      location: {
        lati: undefined,
        longi: undefined,
        addrLati: undefined,
        addrLong: undefined,
      },
      storeAddressSearch: "",
      storeAddressCity: "",
      formValidate: initFormValidate,
      ruleValidate: ruleValidate,
      retCode: retCode,
      tradeType: [],
      basicStoreArea: [],
      addressData: [],
      addressArray: [],
      addressAtpidsData: [],
      shopInfoDeatil: {},
      baseRetailerTypeList: [],
      platformCodeList: [
        { label: "易购APP", value: "0001" },
        { label: "微信小程序门店版", value: "0002" },
        { label: "易掌柜", value: "0003" },
        { label: "业务管理后台", value: "0004" },
      ],
    };
  },
  computed: {
    showTradeType() {
      const { tradeType } = this.formValidate;
      return tradeType.includes("01");
    },
    showCertificateType() {
      const { certificateType } = this.formValidate;
      return certificateType.indexOf("01") > -1;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getBaseAreaQueryAll();
      this.getBaseRetailerType();
      this.getShopInfo();
    },
    async getShopInfo() {
      if (!this.retCode) return false;
      const params = {
        code: this.retCode,
      };
      const { data } = await this.$api["shopInfoQuery"](params);
      this.shopInfoDeatil = data;
      let shopDetails = {
        ...data.retRetailerInfo,
        ...data.retailerPlatform,
        ...data.retailerShippingAddrList[0],
      };
      shopDetails.tradeType = shopDetails.tradeType
        ? shopDetails.tradeType.split(",")
        : [];
      shopDetails.retType = shopDetails.retType
        ? shopDetails.retType.split(",")
        : [];
      shopDetails.receiveAddr = shopDetails.addr;
      this.formValidate = shopDetails;

      if (data.retRetailerInfo.provinceName && data.retRetailerInfo.cityName) {
        this.formValidate.basicStoreArea = [
          data.retRetailerInfo.provinceName + "省",
          data.retRetailerInfo.cityName + "市",
          data.retRetailerInfo.countyName,
        ];
      }

      if (data.retRetailerPhotoList && data.retRetailerPhotoList.length > 0) {
        data.retRetailerPhotoList.map((item) => {
          switch (item.imgName) {
            case "门头照片":
              this.formValidate.shopHeadImg = item.imgUrl;
              break;
            case "店内照片":
              this.formValidate.shopInImg = item.imgUrl;
              break;
            case "门牌号照片":
              this.formValidate.shopNumImg = item.imgUrl;
              break;
            case "食品许可证照片":
              this.formValidate.fblImgUrl = item.imgUrl;
              break;
            default:
              break;
          }
        });
      }
    },
    async getBaseRetailerType() {
      const params = {
        code: this.retCode,
      };
      const { data } = await this.$api["baseRetailerType"](params);
      this.baseRetailerTypeList = data;
    },
    async getBaseAreaQueryAll() {
      const params = {
        code: this.retCode,
      };
      const { data } = await this.$api["baseAreaQueryAll"](params);
      const addressData = this.convertAddressTree(data);
      this.addressData = addressData;
      this.addressArray = this.tools.treeToArray(data);
    },
    handleUpload(v, name) {
      this.formValidate[name] = v;
    },
    handleReset() {
      this.formValidate = initFormValidate;
      this.$refs["formValidate"].resetFields();
      this.$router.back(-1);
    },
    async handleSave() {
      this.$refs["formValidate"].validate(async (valid) => {
        if (valid) {
          if (this.formValidate.storeArea.length > 0) {
            await this.geoCode(
              this.formValidate.storeArea.join(""),
              "longi",
              "lati"
            );
          }

          if (this.formValidate.basicStoreArea.length > 0) {
            await this.geoCode(
              this.formValidate.basicStoreArea.join(""),
              "addrLong",
              "addrLati"
            );
          }

          const info = this.formValidate;
          const location = this.location;
          const params = {
            certificateInfo: {
              certificateType: info.certificateType,
              fblCode: info.fblCode,
              fblImgUrl: info.fblImgUrl,
              imgLecienceUrl: info.imgLecienceUrl,
              lecienceCode: info.lecienceCode,
              lecienceName: info.lecienceName,
              orginizeCode: info.orginizeCode,
              taxlienceType: info.taxlienceType,
              tradeType: info.tradeType ? info.tradeType.join(",") : "",
            },
            channelCode: info.channelCode,
            invoice: {
              bankAccount: info.bankAccount,
              bankName: info.bankName,
              companyAddress: info.companyAddress,
              invoiceCompany: info.invoiceCompany,
              invoiceMobile: info.invoiceMobile,
              invoiceNumber: info.invoiceNumber,
            },
            platformCode: info.platformCode,
            shippingAddr: {
              receiveAddr: info.storeArea
                ? info.storeArea.join("")
                : "" + info.receiveAddr,
              receiveMobile: info.receiveMobile,
              receivePerson: info.receivePerson,
              remark: info.remark,
            },
            storeBaseInfo: {
              businessMobile: info.businessMobile,
              contactMobile: info.contactMobile,
              contractPerson: info.contractPerson,
              dealerCode: info.dealerCode,
              refereeCode: info.refereeCode,
              retType: info.retType ? info.retType.join(",") : "",
              serviceCode: info.serviceCode,
              shopHeadImg: info.shopHeadImg,
              shopInImg: info.shopInImg,
              shopNumImg: info.shopNumImg,
              storeAddress: info.storeAddress,
              storeArea: this.filterArea(
                info.basicStoreArea ? info.basicStoreArea[2] : ""
              ),
              storeClass: info.storeClass,
              storeName: info.storeName,
              zipCode: info.zipCode,
            },
          };
          if (this.retCode) {
            params["retCode"] = this.retCode;
          }

          setTimeout(async () => {
            params.storeBaseInfo.lati = this.location.lati
              ? Number(this.location.lati)
              : undefined;
            params.storeBaseInfo.longi = this.location.longi
              ? Number(this.location.longi)
              : undefined;
            params.shippingAddr.lati = this.location.addrLati
              ? Number(this.location.addrLati)
              : undefined;
            params.shippingAddr.longi = this.location.addrLong
              ? Number(this.location.addrLong)
              : undefined;

            const { data } = this.retCode
              ? await this.$api["shopInfoUpdate"](params)
              : await this.$api["shopInfoAdd"](params);
            this.$Message.success(`${this.retCode ? "更新" : "新增"}门店成功`);
            this.$router.back(-1);
          }, 1000);
        }
      });
    },
    filterArea(area) {
      if (!area) return "";
      const { addressArray } = this;
      const aeraData = addressArray.filter(
        (item) => item.atnames.indexOf(area) > -1
      );
      return aeraData[0].atpids;
    },
    handleSearch() {
      const { basicStoreArea, storeAddress } = this.formValidate;
      if (!storeAddress) {
        this.$Message.error("请先输入详细地址");
        return false;
      }
      if (basicStoreArea.length == 0) {
        this.$Message.error("请先选择所属区域");
        return false;
      }
      this.storeAddressCity = basicStoreArea[1];
      this.storeAddressSearch = storeAddress;
      const area = basicStoreArea.join("");
      this.geoCode(area, "longi", "lati");
    },
    async geoCode(area, lng, lat) {
      const that = this;
      let AMap = (this.AMap = window.AMap);
      var geocoder = new AMap.Geocoder({});

      await geocoder.getLocation(area, (status, result) => {
        if (status === "complete" && result.geocodes.length) {
          const lnglat = result.geocodes[0].location;
          if (lnglat) {
            that.location[lng] = lnglat.lng;
            that.location[lat] = lnglat.lat;
          }
        } else {
          this.$Message.error("根据地址查询位置失败");
        }
      });
    },
    handleBack() {
      this.$router.push({
        path: "manage",
      });
    },
    convertAddressTree(tree) {
      const result = [];

      tree.forEach((item) => {
        let { areaName: value, areaName: label, children } = item;

        if (children) {
          children = this.convertAddressTree(children);
        }
        result.push({ value, label, children });
      });
      return result;
    },
  },
};
</script>

<style>
.store-add .form {
  width: 50%;
  margin: 20px auto;
}
.uploadDiv {
  width: 102px;
  height: 100px;
  background: #f4f6f8;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.uploadText {
  font-size: 13px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeAdd.vue